<template>
  <el-dialog title="手机号重复" :visible="true" width="80%" :close-on-click-modal="false" :show-close="false">
    <div>修改后的调查员手机号已存在，是否合并这 2 个调查员的信息？</div>
    <div>如需合并 2 个调查员信息，请选择合并规则</div>
    <div class="flex mb-4">
      <div class="mr-4">原调查员已有值，编辑值为空时</div>
      <el-radio-group v-model="nullValueRule" class="mt-1">
        <el-radio :label="0">使用导入值</el-radio>
        <el-radio :label="1">保留已有值</el-radio>
      </el-radio-group>
    </div>
    <div class="flex mb-4">
      <div class="mr-4">原调查员已有值，但和编辑值不相同时</div>
      <el-radio-group v-model="differentValueRule" class="mt-1">
        <el-radio :label="0">使用导入值</el-radio>
        <el-radio :label="1">保留已有值</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">不合并，退出编辑</el-button>
      <el-button type="primary" @click="confirm">确认合并</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AgainPhoneDialog",
  data() {
    return {
      nullValueRule: 1,
      differentValueRule: 0
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeInvestigatorEdit')
    },
    confirm() {
      this.$emit('investigatorEdit')
    }
  }
}
</script>
